import React from "react";
import ReactApexChart from "react-apexcharts";

const StudentComparisonChart = ({
  startedData = [],
  completedData = [],
  categories = [],
  title = "مقارنة عدد الطلاب الذين بدأوا وأتموا البرامج",
  height = 400,
}) => {
  const series = [
    {
      name: "بدأوا البرنامج",
      data: startedData,
    },
    {
      name: "أتموا البرنامج",
      data: completedData,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "20%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontFamily: "Cairo",
      },
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    colors: ["#2980b9", "#27ae60"],
    legend: {
      position: "top",
      fontFamily: "Cairo",
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} طالب`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
      <ReactApexChart options={options} series={series} type="bar" height={height} />
    </div>
  );
};

export default StudentComparisonChart;
